import React from 'react';

import {
  CrawlStatus,
} from '../components';

export function fmtCrawlStatus(value) {
  return <CrawlStatus value={value} adornment='start'/>;
}
